module.exports = __webpack_public_path__ + "html/section-company-info_8f30a408b2003b1a1066411540e49517.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-company-info.html
// module id = JO6v
// module chunks = 93